import { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Prefix, useAppPrefix } from '@/shared/lib/hooks/use-app-prefix.hook';
import { PageLoader } from '@/widgets/page';

import { SectorRoutes } from '../sector-routers';

const RouterComponent = () => {
	const sectorPrefix = useAppPrefix();

	return (
		<Routes>
			<Route path="/" element={<Navigate to={sectorPrefix} replace />} />

			<Route
				path={`${Prefix.Yachting}/*`}
				element={
					<Suspense fallback={<PageLoader />}>
						<SectorRoutes />
					</Suspense>
				}
			/>
			<Route
				path={`${Prefix.Industrial}/*`}
				element={
					<Suspense fallback={<PageLoader />}>
						<SectorRoutes />
					</Suspense>
				}
			/>
		</Routes>
	);
};

export default RouterComponent;
